import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {AuthService} from './auth.service';
import {environment} from './../../environments/environment';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class RequesterService {

    constructor(
        protected httpClient: HttpClient,
        protected authService: AuthService,
        protected router: Router
    ) {
    }

    protected getHeaders() {
        let headers = new HttpHeaders()
            .set('X-Api-Version', environment.appApiVersion.toString(10))
            .set('X-App-Version', 'LearningJourney/' + this.authService.appPlatform + '/' + environment.appVersionNumber);

        const token = this.authService.getToken();
        if (token !== null) {
            headers = headers.set('Authorization', 'Bearer ' + token);
        }
        return headers;
    }

    protected getApiUrl(method: string): string {
        return environment.appApiUrl + method;
    }

    protected getParams(addParams) {
        let params = null;
        if (addParams !== null) {
            params = new HttpParams();
            for (const key of Object.keys(addParams)) {
                params = params.set(key, addParams[key]);
            }
        }
        return params;
    }

    protected getRequestErrorHandler() {
        return (e) => {
            console.error('Request error >>', e);
            if (!e.ok) {
                if (e.status === 0) {
                    setTimeout(() => {
                        this.router.navigate(['/static/serviceUnavailable']);
                    });
                }
                if (e.status === 401) {
                    if (e.url.indexOf('/api2/login') === -1) {
                        this.authService.logout();
                    } else {
                        return e.error;
                    }
                }
            }
            throw e.error;
        };
    }

    protected getRequestHandler() {
        return (data) => {
            const renewToken = data.headers.get('X-Renew-Token');
            if (!!renewToken) {
                this.authService.setToken(renewToken);
            }
            return data.body;
        };
    }

    ping() {
        const headers = this.getHeaders();
        const url = this.getApiUrl('ping');
        return this.httpClient.get(url, {headers, observe: 'response'})
            .toPromise();
    }

    get(method: string, addParams = null) {
        const params = this.getParams(addParams);
        const headers = this.getHeaders();
        const url = this.getApiUrl(method);
        return this.httpClient.get(url, {headers, params, observe: 'response'})
            .toPromise()
            .then(this.getRequestHandler())
            .catch(this.getRequestErrorHandler());
    }

    post(method: string, data: any = null) {
        const headers = this.getHeaders();
        const url = this.getApiUrl(method);
        return this.httpClient.post(url, data, {headers, observe: 'response'})
            .toPromise()
            .then(this.getRequestHandler())
            .catch(this.getRequestErrorHandler());
    }

    put(method: string, data: any = null) {
        const headers = this.getHeaders();
        const url = this.getApiUrl(method);
        return this.httpClient.put(url, data, {headers, observe: 'response'})
            .toPromise()
            .then(this.getRequestHandler())
            .catch(this.getRequestErrorHandler());
    }

    delete(method: string, addParams = null) {
        const params = this.getParams(addParams);
        const headers = this.getHeaders();
        const url = this.getApiUrl(method);
        return this.httpClient.delete(url, {headers, params, observe: 'response'})
            .toPromise()
            .then(this.getRequestHandler())
            .catch(this.getRequestErrorHandler());
    }

    customRequest(xhr: XMLHttpRequest, method: string, url: string, formData: any) {
        xhr.open(method, this.getApiUrl(url), true);
        xhr.setRequestHeader('X-Api-Version', environment.appApiVersion.toString(10));
        const token = this.authService.getToken();
        if (token !== null) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        }
        xhr.send(formData);
    }
}
